import { render } from "./TestPartsDB.vue?vue&type=template&id=573f82ac&scoped=true"
import script from "./TestPartsDB.vue?vue&type=script&lang=js"
export * from "./TestPartsDB.vue?vue&type=script&lang=js"

import "./TestPartsDB.vue?vue&type=style&index=0&id=573f82ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-573f82ac"]])

export default __exports__